

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-tracking/dist/index', 'components/ul-inline/dist/inject', 'onetouch-interstitial/kmliUpsell', 'components/xo-device-info/dist/index'], function ($, angular, squid, template) {

    return angular.module('xo-fullpage-onetouch-upsell.directive', ['squid', 'xolocale', 'tracking', 'xo-device-info']).directive('xoFullpageOnetouchUpsell', function () {

        return {
            template: template,
            scope: {
                token: '='
            },
            controller: function controller($scope, $rootScope, $state, $element, $timeout, $logger, $LocaleModel, $locale, $CalDataModel, $config, $meta, $KmliUpsell, $DeviceInfo) {

                $scope.locale = $LocaleModel.instance();
                $scope.disableCloseButton = $DeviceInfo.isDevice();
                var ulMeta = $config.ulMeta || {};
                var PAYPAL = window.PAYPAL || {};
                var ulTimeOutValue = 5000;
                var ulTimeoutPromise = null;
                var styleSet = false;

                var fptiData = $KmliUpsell.getFPTIAttributes();

                function deInitStyles() {
                    $('#paypalLogo').show();
                    $('.footer').show();
                    $('.paypalHeaderWrapper.span14').attr('style', '');
                    $('.row-fluid.paypalHeaderWrapper').show();
                }

                function closeInterstitial() {
                    deInitStyles();
                    $state.go('checkout.review');
                }

                function failureHandler(reason) {
                    $logger.info('KMLI_UPSELL_error_' + reason);
                    closeInterstitial();
                }

                var startTimerTS;
                function startTimer(tag) {
                    startTimerTS = Date.now();
                    $logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
                        startTime: startTimerTS
                    });

                    $logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'prepare_' + tag
                    });

                    ulTimeoutPromise = $timeout(function () {
                        var stop_time = Date.now();
                        var time_taken = stop_time - startTimerTS;
                        $logger.info('checkout_fpti', {
                            'from': 'Interstitial_Timer',
                            'to': 'process_timeout',
                            'int_error_code': 'ULLOGIN_TIMEOUT',
                            'int_error_description': 'ULLOGIN_TIMEOUT',
                            'error_source': 'unifiedloginnodeweb',
                            'error_type': 'soft_decline',
                            'page_load_time': time_taken
                        });
                        failureHandler('timedout');
                        $rootScope.$emit('loaded');
                    }, ulTimeOutValue);
                }

                function stopTimer(tag) {
                    var stopTimerTS = Date.now();
                    var timeTaken = stopTimerTS - startTimerTS;
                    $logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
                        stopTimer: stopTimerTS,
                        page_load_time: timeTaken
                    });

                    $logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'process_' + tag,
                        'page_load_time': timeTaken
                    });

                    if (ulTimeoutPromise) {
                        $timeout.cancel(ulTimeoutPromise);
                    }
                }

                function logSubmit(data) {
                    var fptiPayload = {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'optin'
                    };
                    if (data && data.errorCode) {
                        angular.extend(fptiPayload, {
                            'int_error_code': data.errorCode,
                            'error_type': 'hard_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                    }
                    $logger.info('checkout_fpti', fptiPayload);
                }

                $scope.$on('$locationChangeStart', function (event, next, current) {
                    if (styleSet) {
                        deInitStyles();
                    }
                });

                $scope.hideModal = function (event) {
                    if (event) {
                        event.preventDefault();
                    }

                    $logger.info('checkout_fpti', {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'decline',
                        'click_source': 'close_button'
                    });

                    closeInterstitial();
                };

                var ulEventHandlers = {
                    'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                        stopTimer(data.event);
                        $rootScope.$emit('loaded');
                        $('#paypalLogo').hide();
                        $('.footer').hide();
                        $('.paypalHeaderWrapper.span14').attr('style', 'border:none;');
                        $('.row-fluid.paypalHeaderWrapper').hide();
                        styleSet = true;
                    },
                    'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                        $rootScope.$emit('loading');
                        startTimer(data.event);
                    },
                    'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                        stopTimer(data.event);
                        $rootScope.$emit('loaded');
                        logSubmit();
                        closeInterstitial(data);
                    },
                    'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                        stopTimer(data.event);
                        $rootScope.$emit('loaded');
                        logSubmit({ errorCode: data.event });
                        closeInterstitial(data);
                    },
                    'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                        stopTimer(data.event);
                        logSubmit({ errorCode: data.event });
                        $rootScope.$emit('loaded');
                        closeInterstitial(data);
                    },
                    'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
                        $logger.info('checkout_fpti', {
                            'from': fptiData.stateName,
                            'to': 'process' + fptiData.transInfix + 'decline',
                            'click_source': 'not_now_link'
                        });
                        closeInterstitial(data);
                    }
                };

                function postMessageHandler(response) {
                    $timeout(function () {
                        $logger.info('ul_postmessaged_received', response);
                        var data = response.data || response.error;
                        var eventId = data && data.event;
                        if (eventId) {
                            $logger.debug('KMLI_UPSELL_' + eventId, response);
                            var handler = ulEventHandlers[eventId];
                            if (handler) {
                                handler(data);
                            }
                        }
                    });
                }

                function loadOneTouchUpsell() {
                    $rootScope.$emit('loading');
                    var options = {
                        targetElement: document.getElementById('injectedOneTouchInterstitial'),
                        queryParams: {
                            'stsRedirectUri': ulMeta.stsReturnUrl,
                            'country.x': $scope.locale.country,
                            'locale.x': $scope.locale.getLocaleCode(),
                            'flowId': $scope.token,
                            'correlationId': $CalDataModel.getCalCorrId(),
                            'flowName': 'checkout'
                        },
                        iframePathname: '/signin/activate-one-touch',
                        onPostMessage: postMessageHandler
                    };

                    angular.extend(options.queryParams, $KmliUpsell.getOptions());

                    if ($config.deploy.isLocal()) {
                        options.origin = 'https://' + $meta.stage;
                    }

                    if (PAYPAL && PAYPAL.unifiedLogin) {
                        startTimer('initializeUpsell');
                        PAYPAL.unifiedLogin.inject(options);
                    } else {
                        failureHandler('PAYPAL.unifiedLogin_undefined');
                    }
                }

                loadOneTouchUpsell();
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/fullpage-onetouch-upsell/directive.js
// module id = ./components/xo-login-components/src/fullpage-onetouch-upsell/directive.js
// module chunks = 1